<script>
  import csc from "country-state-city";
  import Multiselect from 'vue-multiselect'

  export default {
    props: { address: Object, index: Number, member: Object },

    components: {
      Multiselect
    },

    data() {
      return {
        countries: csc.getAllCountries(),
        states: csc.getStatesOfCountry('101'),
        cities: csc.getCitiesOfState('22'),
        typeofAddresses: [
          'Home', 'Office', 'Other'
        ],
      }
    },

    computed: {
      members() {
         let members =  this.member.relationships.map((member) => {
            return member.first_name;
         });

         members.push(this.member.first_name);

         return members;
      }
    },

    watch: {
      'address.country': function(selectedCountry){
        this.states = csc.getStatesOfCountry(selectedCountry.id);
      },
      'address.state': function(selectedState){
        this.cities = csc.getCitiesOfState(selectedState.id);
      }
    },

    methods: {
      resetStateCity: function() {
        this.address.state=null;
        this.address.city=null;
      },

      resetCity: function() {
        this.address.city=null;
      }
    },

    created() {

      /*if( this._.hasIn(this.address,'pivot.private') ) {
        this.address.private = this.address.pivot.private;
        this.address.belongsTo = this._.map(this.address.members, (member) => {
          return member.first_name;
        });
      }*/

      this.address.country = JSON.parse(this.address.country);
      this.address.state = JSON.parse(this.address.state);
      this.address.city = JSON.parse(this.address.city);

      if(this.address.country == null){
        this.address.country = csc.getCountryById('101')
      }
      if(this.address.state == null){
        this.address.state = csc.getStateById('22')
      }
      if(this.address.city == null){
        this.address.city = csc.getCityById('2707')
      }
    }
  }
</script>

<template>
  <form>
    <b-row class="mb-4">
      <b-col md="2">
        <label class="required">Address Type</label>
      </b-col>
      <b-col md="10">
        <multiselect
                v-model="address.type"
                :options="typeofAddresses"
                :multiple="false"></multiselect>
      </b-col>
    </b-row>

    <div class="form-group row mb-4">
      <label class="col-md-2 col-form-label required">Country</label>
      <div class="col-md-10">
        <multiselect
                v-model="address.country"
                @select="resetStateCity"
                label="name"
                :options="countries"
                :multiple="false"></multiselect>
      </div>
    </div>

    <div class="form-group row mb-4">
      <label class="col-md-2 col-form-label required">State</label>
      <div class="col-md-10">
        <multiselect
                v-model="address.state"
                @select="resetCity"
                label="name"
                :options="states"
                :multiple="false"></multiselect>
      </div>
    </div>

    <div class="form-group row mb-4">
      <label class="col-md-2 col-form-label required">City</label>
      <div class="col-md-10">
        <multiselect
                v-model="address.city"
                label="name"
                :options="cities"
                :multiple="false"></multiselect>
      </div>
    </div>

    <b-row class="mb-4">
      <b-col md="2">
        <label>Area</label>
      </b-col>
      <b-col md="10">
        <b-form-input v-model="address.area" id="area" name="area" placeholder="Enter area"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label class="required">Address Line 1</label>
      </b-col>
      <b-col md="10">
        <b-form-input v-model="address.line_1" name="line_1" placeholder="Enter address line 1"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label>Address Line 2</label>
      </b-col>
      <b-col md="10">
        <b-form-input v-model="address.line_2" name="line_2" placeholder="Enter address line 2"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col md="2">
        <label>Address Line 3</label>
      </b-col>
      <b-col md="10">
        <b-form-input v-model="address.line_3" name="line_3" placeholder="Enter address line 3"></b-form-input>
      </b-col>
    </b-row>

    <div class="form-group row mb-4">
      <label class="col-md-2 col-form-label">Pincode</label>
      <div class="col-md-10">
        <b-form-input v-model="address.pincode" id="pincode" name="pincode" placeholder="Enter Pincode"></b-form-input>
      </div>
    </div>

    <div class="custom-control custom-checkbox mb-3">
      <input
              type="checkbox"
              v-model="address.pivot.private"
              :id="'prvAddress'+index"
              class="custom-control-input"
      />
      <label :for="'prvAddress'+this.index" class="custom-control-label">
        Private Address
        <p class="small text-muted">
          Address won't be copied to all family members.
        </p>
      </label>
    </div>

    <div class="form-group row mb-4" v-if="address.pivot.private">
      <label class="col-md-2 col-form-label">Who lives here?</label>
      <div class="col-md-10">
        <multiselect v-model="address.members" :options="members" :multiple="true">
        </multiselect>
      </div>
    </div>

  </form>
</template>
